"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.timestampToDate = exports.dateToTimestamp = exports.now = void 0;
/**
 * The current timestamp (in Unix epoch milliseconds)
 *
 * @returns
 */
function now() {
    return new Date().getTime();
}
exports.now = now;
/**
 * Convert from a Javascript date to Unix epoch milliseconds
 *
 * @param date
 * @returns
 */
function dateToTimestamp(date) {
    return date.getTime();
}
exports.dateToTimestamp = dateToTimestamp;
/**
 * Convert from unix epoch milliseconds to a Javascript Date
 *
 * @param ts
 * @returns
 */
function timestampToDate(ts) {
    return new Date(ts);
}
exports.timestampToDate = timestampToDate;
